var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMemo = function SvgMemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.333h9.167V10H2.5V8.333Zm0-1.666h9.167V5H2.5v1.667Zm0 6.666h5.833v-1.666H2.5v1.666Zm12.508-2.608.592-.592a.831.831 0 0 1 1.175 0l.592.592a.83.83 0 0 1 0 1.175l-.592.592-1.767-1.767Zm-.591.592L10 15.733V17.5h1.767l4.416-4.417-1.766-1.766Z",
    fill: "#08092D"
  })));
};
export default SvgMemo;